import { getContrast } from "core/utils/utils";
import InteractiveCanvas from "./InteractiveCanvas";
import elements, { elementHighest } from "./services/elementService";
import { BLACK, GRAY, RED } from "./theme/palette";

const DRAW_TEXT_BP = 35;
const DRAW_FULL_TEXT_BP = 80;
class PeriodicTableCanvas extends InteractiveCanvas {
  constructor(props) {
    super({
      ...props,
      onSelect: props.onSelect
        ? (y, x) => {
            const rx = x;
            const ry = 10 - y;
            const el = elements.find((el) => el.px === rx && el.py === ry);
            return props.onSelect(el);
          }
        : undefined,
      maxBlockX: elementHighest.x + 1,
      maxBlockY: elementHighest.y,
    });
    this.TAG = "PERIODIC_TABLE";
  }

  getElementFromTarget() {
    const index = Math.floor(this.selectedTarget?.proton - 1);
    return elements[index];
  }

  drawElement(el) {
    const { x, y } = this.getXYFromNP(el.px, elementHighest.y - el.py);

    const hbp = this.bp / 2;
    const color = el.getColor();

    this.ctx.fillStyle = getContrast(color);
    this.ctx.strokeRect(x, y, this.bp, this.bp);

    const contrast = getContrast(color, true);
    this.ctx.fillStyle = contrast;

    this.ctx.strokeRect(x, y, this.bp, this.bp);

    if (this.bp >= this.cp(DRAW_TEXT_BP)) {
      this.drawText(
        el.atomicNum,
        x + hbp,
        y + this.bp * 0.25,
        `bold ${this.bp / 6}px`
      );

      const symbolFontSize = this.bp / 3;
      this.drawText(
        el.symbol,
        x + hbp,
        y + hbp + symbolFontSize / 2,
        `bold ${symbolFontSize}px`
      );

      const nameFontSize = this.bp / 8;
      this.drawText(
        el.name,
        x + hbp,
        y + this.bp * 0.75 + nameFontSize,
        `bold ${nameFontSize}px`
      );
    } else {
      this.drawText(
        el.atomicNum,
        x + hbp,
        y + this.bp * 0.3,
        `bold ${this.bp / 4}px`
      );

      const symbolFontSize = this.bp / 2.25;
      this.drawText(
        el.symbol,
        x + hbp,
        y + this.bp * 0.55 + symbolFontSize / 2,
        `bold ${symbolFontSize}px`
      );
    }
  }

  draw() {
    //clear canvas
    this.ctx.globalAlpha = 1;
    this.ctx.clearRect(0, 0, this.canvasWidth, this.canvasHeight);

    this.ctx.fillStyle = BLACK;
    this.ctx.textAlign = "center";
    this.ctx.lineWidth = this.cp(1);
    this.ctx.strokeStyle = GRAY;

    const y = Math.floor(this.viewCoord.y);
    const x = Math.floor(this.viewCoord.x);

    const my = this.canvasHeight / this.bp / 2;
    const mx = this.canvasWidth / this.bp / 2;
    let yMin = Math.floor(y - my - this.renderExtra);
    let xMin = Math.floor(x - mx - this.renderExtra);
    let yMax = Math.floor(y + my + this.renderExtra);
    let xMax = Math.floor(x + mx + this.renderExtra);
    for (const el of elements) {
      const py = elementHighest.y - el.py;
      if (el.px >= xMin && el.px <= xMax && py >= yMin && py <= yMax) {
        this.drawElement(el);
      }
    }

    //if there is a target, highlight target
    const selectedEl = this.getElementFromTarget();
    if (selectedEl) {
      this.ctx.globalAlpha = 0.7;
      const { x, y } = this.getXYFromNP(
        selectedEl.px,
        elementHighest.y - selectedEl.py
      );
      this.ctx.lineWidth = this.cp(2);
      this.ctx.strokeStyle = RED;

      this.ctx.strokeRect(x, y, this.bp, this.bp);

      this.ctx.lineWidth = this.cp(this.bp >= this.cp(DRAW_TEXT_BP) ? 2 : 1);

      if (this.bp < this.cp(DRAW_FULL_TEXT_BP)) {
        this.drawCross(x, y);
      }
    }
  }
}

export default PeriodicTableCanvas;
